import { SentimentVeryDissatisfied } from '@mui/icons-material';
import {
  Card,
  CardHeader,
  Divider,
  useMediaQuery,
  Box,
  Typography,
  Button,
  Tooltip,
} from '@mui/material';
import type { Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PropertyList } from '../../../../../components/atoms/property-list';
import { PropertyListItem } from '../../../../../components/atoms/property-list-item';
import { Host } from '../../../api/types/host';

import { Can } from '@/permissions/can';

interface Props {
  host: Host;
  handleOpenGroupDialog: () => void;
}

export const BillingGroupInfo = ({ host, handleOpenGroupDialog }: Props) => {
  const { t } = useTranslation(['host', 'billingGroups', 'common']);

  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const align = mdDown ? 'vertical' : 'horizontal';

  return (
    <Card variant="outlined">
      <CardHeader
        title={t('host:billingGroup.cardTitle')}
        action={
          <Can I="manageBillingGroup" a="Hosts" passThrough>
            {allowed => (
              <Tooltip
                title={t('common:notSufficientPermissions')}
                disableHoverListener={allowed}
                disableFocusListener={allowed}>
                <span>
                  <Button
                    sx={{ ml: 2 }}
                    disabled={!host.allowInviteToParking || !allowed}
                    onClick={handleOpenGroupDialog}>
                    {t('host:billingGroup.setBillingGroup')}
                  </Button>
                </span>
              </Tooltip>
            )}
          </Can>
        }
      />
      <Divider />
      {host?.billingGroup ? (
        <PropertyList>
          <PropertyListItem
            align={align}
            label={t('billingGroups:table.name')}
            value={host.billingGroup.name}
          />
          {host.billingGroup?.discountTemplates?.map((el, i) => (
            <PropertyListItem
              key={i}
              align={align}
              label={`${t('host:billingGroup.discount')} #${i + 1}`}
              value={el.name}
            />
          ))}
        </PropertyList>
      ) : (
        <Box sx={{ p: 3, display: 'flex', alignItems: 'center' }}>
          <Typography color="primary.main" variant="body2">
            {t('host:billingGroup.noGroup')}
          </Typography>
          <SentimentVeryDissatisfied sx={{ color: 'primary.main' }} />
        </Box>
      )}
    </Card>
  );
};
